module.exports = __webpack_public_path__ + "img/44F7DA39-467B-4317-BD97-15B8B39F0D7A.aacf2763.png";